import { getComponentsFromMap } from '../utils'

import CStrTpl from './str-tpl/CStrTpl.vue'
import CInfoSection from './section/CInfoSection.vue'
import CInfoCard from './section/CInfoCard.vue'

import {
  CAppBaseTheme,
  CAppHeaderExtra,
  CAppNotifyContainer,
  CAppSearchBar,
  CAppOverlay,
  CAppHomeMenu,
  CAppMenuExtra,
  CAppSideDrawer,
  CAppSideAction,
  CAppSidePanel,
  CAppBoard,
  CAppBoardItem,
  CAppBoardSection,
  CBoardCard,
  CBoardItemText,
  CBoardItemHtml
} from './app'

import {
  CFormItemArea,
  CFormItemAreaMerged,
  CFormItemAreaQcp,
  CFormItemAreaAll,
  CFormItemMultiArea,
  CFormItemMultiAreaEx,
  CFormItemMultiAreaExMerged,
  CFormItemMultiAreaMerged,
  CFormItemLabelImage,
  CFormItemLabelVideo,
  CFormItemDisInput,
  CFormItemInputLink,
  CFormItemMultiInput,
  CFormItemMultiInputEx,
  CFormItemMultiLabel,
  CFormItemOrg,
  CFormItemAreaOrg
} from './form'

import CVerifyCode from './security/CVerifyCode.vue'
import CArea from './area/CArea.vue'
import CAreaMerged from './area/CAreaMerged.vue'
import CAreaQcp from './area/CAreaQcp.vue'
import CAreaAll from './area/CAreaAll.vue'
import CMap from './map/CMap.vue'

import CCharts from './chart/CCharts.vue'

import CDataSearchForm from './data/search/CDataSearchForm.vue'
import CDataAnalysisDate from './data/analysis/CDataAnalysisDate.vue'

const components = getComponentsFromMap({
  CAppBaseTheme,
  CAppHeaderExtra,
  CAppNotifyContainer,
  CAppSearchBar,
  CAppOverlay,
  CAppHomeMenu,
  CAppMenuExtra,
  CAppBoard,
  CAppBoardItem,
  CAppBoardSection,
  CBoardCard,
  CBoardItemText,
  CBoardItemHtml,

  CAppSideDrawer,
  CAppSideAction,
  CAppSidePanel,

  CStrTpl,
  CInfoSection,
  CInfoCard,
  CFormItemArea,
  CFormItemAreaMerged,
  CFormItemAreaQcp,
  CFormItemAreaAll,
  CFormItemMultiArea,
  CFormItemMultiAreaEx,
  CFormItemMultiAreaExMerged,
  CFormItemMultiAreaMerged,
  CFormItemLabelImage,
  CFormItemLabelVideo,
  CFormItemDisInput,
  CFormItemInputLink,
  CFormItemMultiInput,
  CFormItemMultiInputEx,
  CFormItemMultiLabel,
  CVerifyCode,
  CArea,
  CAreaMerged,
  CAreaQcp,
  CAreaAll,
  CMap,
  CCharts,
  CDataSearchForm,
  CDataAnalysisDate,
  CFormItemOrg,
  CFormItemAreaOrg
})

export { components }
